// extracted by mini-css-extract-plugin
export default {"filter":"SimpleDropdown_filter__H1cJU","selectedOptionLabel":"SimpleDropdown_selectedOptionLabel__KQ3-R"};